<mat-accordion hideToggle>
    <mat-expansion-panel
        [expanded]="expanded()"
        (closed)="expanded.set(false)"
        (opened)="expanded.set(true)"
        (toggle)="toggle()"
    >
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon
                    class="collapsable-arrow"
                    svgIcon="ico_accordion_caret_right"
                    [ngClass]="{ expanded: expanded() }"
                ></mat-icon>
                {{ title() }}
            </mat-panel-title>
            <mat-panel-description>{{ description() }}</mat-panel-description>
        </mat-expansion-panel-header>
        <ng-content />
    </mat-expansion-panel>
</mat-accordion>
